import PropTypes from 'prop-types';
import cx from 'classnames';

import themePropTypes from 'core/utils/prop-types/theme';
import withTheme from 'core/hocs/withTheme';

import { Mobile, Desktop } from 'core/components/breakpoint';

import IconDesktop from './images/desktop.svg';
import IconMobile from './images/mobile.svg';

import styles from './index.styl';


function LoginButton({ theme, handleAuth, hidden }) {
  const {
    controls: {
      shapka: {
        link: shapkaLinkAtoms,
      },
    },
  } = theme;

  return (
    <>
      <style jsx>{`
        .${styles.login}
          :global(.desktop) &
            font ${shapkaLinkAtoms.font}
            text-transform ${shapkaLinkAtoms.textTransform}
            letter-spacing ${shapkaLinkAtoms.letterSpacing}
            color ${shapkaLinkAtoms.idle.color}
            text-decoration ${shapkaLinkAtoms.idle.decoration}
        `}
      </style>
      <button
        className={cx(styles.login, hidden && styles._hidden)}
        onClick={handleAuth}
      >
        <Desktop>
          <span>Войти</span>
          <IconDesktop />
        </Desktop>
        <Mobile>
          <IconMobile />
        </Mobile>
      </button>
    </>
  );
}

LoginButton.propTypes = {
  handleAuth: PropTypes.func,
  /** @ignore */
  theme: themePropTypes(`{
    controls: {
      shapka: {
        link: {
          font,
          textTransform,
          letterSpacing,
          idle: {
            color,
            decoration,
          },
        },
      },
    },
  }`),
  hidden: PropTypes.bool,
};

const LoginButtonWithHOCs = withTheme(LoginButton);
LoginButtonWithHOCs.displayName = 'LoginButton';

export { LoginButton as StorybookComponent };
export default LoginButtonWithHOCs;
